export const iconFontAwesomeUsersPeopleUserAstronaut = (
	<i className="fa-solid fa-user-astronaut"></i>
);
